"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedwalletwithcard = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedwalletwithcard` : '') + (description ? ` desc-brandedwalletwithcard` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedwalletwithcard"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedwalletwithcard"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#cc0058",
    d: "M62 44.92c0 .9-.4 1.75-1.1 2.39-.7.63-1.66.99-2.65.99H5.75c-1 0-1.95-.36-2.65-1A3.2 3.2 0 0 1 2 44.92V11.16c0-.9.4-1.76 1.1-2.4.7-.62 1.66-.98 2.65-.98h52.5c1 0 1.95.36 2.65.99s1.1 1.5 1.1 2.39z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#ffc599",
    fillOpacity: ".5",
    d: "M32.67 19.72H60.8v.7H32.67z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    fillOpacity: ".12",
    d: "M32.67 19.11H60.8v.7H32.67z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#e90b5a",
    d: "M39.5 23.57q0-1.02-.64-1.9a3.7 3.7 0 0 0-1.72-1.23L4.57 8.7a2 2 0 0 0-1.75.17q-.38.23-.6.6-.22.38-.22.8V46q0 1.03.64 1.9c.42.55 1.02.98 1.72 1.23l30 12.42a4.1 4.1 0 0 0 3.5-.34q.77-.48 1.2-1.21.44-.75.44-1.59z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#f26b1c",
    d: "M20.75 49.14q0-.2.1-.38a1 1 0 0 1 .29-.3 1 1 0 0 1 .84-.12l9.38 3.33q.29.1.46.3.18.23.18.5v1.73q0 .21-.1.39a1 1 0 0 1-.29.3 1 1 0 0 1-.84.12l-9.38-3.34a1 1 0 0 1-.46-.3 1 1 0 0 1-.18-.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#paint0_linear_29750_2545)",
    fillRule: "evenodd",
    d: "M14.8 2a4 4 0 0 0-4 4v4.95L33.16 19H60.8V6a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M49.95 16.42a1 1 0 0 1 1.16.19l1.78 1.7-.76.72h-2.7a1 1 0 0 1 .26-.44l.27-.28-.27-.28a1 1 0 0 1 .26-1.6M17.18 9.36q.02.38.36.39.36 0 .37-.4V8.23h.3v1.15c0 .43-.3.66-.67.66s-.66-.23-.66-.66V8.22h.3zm13.86 0q.01.38.37.39.36 0 .37-.4V8.23h.3v1.15c0 .43-.3.66-.67.66s-.66-.23-.66-.66V8.22h.3zM51.9 8.18c.41 0 .57.26.61.45l-.27.09c-.01-.11-.1-.27-.34-.27-.18 0-.31.12-.31.25q0 .17.2.23l.26.05c.32.06.48.26.49.5 0 .28-.23.55-.63.55-.45 0-.66-.3-.7-.55l.29-.08c.02.19.15.36.4.36q.33-.02.33-.25 0-.17-.24-.24l-.25-.05c-.27-.05-.45-.23-.45-.5 0-.3.27-.54.6-.54M19.22 9.7h.82v.3h-1.12V8.2h.3zm2.5-1.2h-.58V10h-.3V8.5h-.58v-.3h1.46z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.66 10h-.33l-.17-.45h-.75l-.17.44h-.32l.7-1.78h.34zm-1.15-.73h.54l-.27-.73zm3.23-1.05c.34 0 .54.2.54.48a.4.4 0 0 1-.26.38q.3.09.32.42c0 .29-.22.5-.55.5h-.66V8.21zm-.32 1.52h.31q.28-.01.3-.26 0-.25-.29-.26h-.32zm0-.77h.28q.27-.01.28-.25 0-.24-.29-.25h-.27zM30.27 10h-.33l-.17-.45h-.75l-.17.44h-.32l.7-1.78h.35zm-1.15-.73h.55l-.27-.73z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M34.07 8.5h-.58V10h-.3V8.5h-.58v-.3h1.46zm1.2.46.43-.74h.34l-.63 1.02V10h-.3v-.75l-.62-1.02h.35zm-7.21-.46h-.8v.47h.72v.27h-.72v.47h.8v.28h-1.1V8.21h1.1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M39.7 8.22c.34 0 .55.24.55.54a.5.5 0 0 1-.4.5l.4.73h-.34l-.37-.7h-.22v.7h-.3V8.22zm-.38.8h.32q.3 0 .3-.27 0-.25-.3-.27h-.32z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M41.97 8.5h-.8v.47h.73v.27h-.72v.47h.8v.28h-1.1V8.22h1.1zm1.16 1.01.42-1.3h.31l.43 1.31.34-1.3h.32l-.5 1.77h-.31l-.43-1.34-.44 1.34h-.3l-.5-1.77h.3z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M46.84 9.99h-.33l-.16-.44h-.76l-.16.44h-.32l.7-1.77h.34zm-1.14-.72h.54l-.27-.73zm2.36-1.05c.35 0 .56.24.56.54a.5.5 0 0 1-.4.5l.4.73h-.34l-.37-.7h-.22v.7h-.3V8.22zm-.37.8H48q.3 0 .3-.27 0-.25-.3-.27h-.32zm2.18-.8c.49 0 .87.32.87.89s-.39.88-.87.88h-.63V8.22zm-.33 1.5h.32c.3 0 .56-.2.56-.61s-.25-.62-.56-.62h-.32z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M37.54 8.65a.33.33 0 0 1 .46.47l-.56.58-.55-.58a.33.33 0 1 1 .47-.47l.08.1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M52.92 8.28q.08 0 .08.09 0 .05-.04.07l.05.1h-.07l-.04-.1h-.02v.1h-.06v-.26zm-.04.12h.03q.03 0 .03-.03t-.03-.04h-.03z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M52.9 8.18a.23.23 0 1 1 0 .47.24.24 0 0 1 0-.47m0 .05q-.16.01-.18.18.02.17.18.19.17-.01.18-.19-.01-.17-.18-.18",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear_29750_2545",
    x1: "10.8",
    x2: "60.8",
    y1: "10.52",
    y2: "10.52",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".57",
    stopColor: "#f26b1c"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#e90b5a"
  }))));
};
var _default = exports.default = brandedwalletwithcard;